const roleOptions = [
  { value: 2, label: 'Admin' },
  { value: 3, label: 'Technician' },
];

export default roleOptions;
